import React from 'react';

import { PlansOverview } from '../../components/Billing';

export default function PlansOverviewPage() {
	return <PlansOverview />;
}
